import Tooltip from "PFComponents/tooltip/tooltip";
import React from "react";

import { useCalendarContext } from "../../../../context/calendar_context";
import { OverbookingWithThreshold } from "../use_group_items_by_threshold";
import { OverbookingTooltipContent } from "./overbooking_tooltip_content";
import css from "./overbookings_bar.module.scss";

type OverbookingsBarTooltipsProps = {
  overbookingsWithThreshold: OverbookingWithThreshold;
  duration: number;
};

export const OverbookingsBarTooltips = ({
  overbookingsWithThreshold
}: OverbookingsBarTooltipsProps): JSX.Element => {
  const { dayWidth } = useCalendarContext();
  const { overbookings, threshold } = overbookingsWithThreshold;
  return (
    <div>
      {overbookings.map((overbooking, index) => (
        <Tooltip
          key={`overbooking-tooltip-${overbooking.date}`}
          content={<OverbookingTooltipContent overbooking={overbooking} threshold={threshold} />}
        >
          <div
            className={css.overBookingTooltip}
            style={{
              width: dayWidth,
              left: index * dayWidth
            }}
          />
        </Tooltip>
      ))}
    </div>
  );
};
